import React, {Component} from "react";
import {Badge, Button, Input, Space, Table, Tooltip} from "antd";
import {
    YoutubeOutlined as Youtube,
    FileOutlined as File, CloseOutlined, SearchOutlined, ReloadOutlined, PrinterOutlined, PrinterFilled
} from '@ant-design/icons';
import moment from "moment";
import {DataTypes} from "../../data/types";
import {CompositionFilterModal} from "./CompositionFilterModal";
import {amIAdmin} from "../../helpers/auth";

export class CompositionList extends Component {
    state = {
        fullText: '',
        filterModalVisible: false
    }

    onRow = (record) => {
        return {
            onClick: () => {
                this.props.onSelect(record)
            }
        };
    }

    setRowClassName = (record) => {
        return record.id === this.props.current.id ? 'selectable ant-table-row-selected' : 'selectable';
    }

    filterFullText = (text) => {
        const params = {
            ...this.props[`${DataTypes.COMPOSITIONS}_params`],
            page: 1,
            fulltext: text
        };
        this.props.loadCollection(DataTypes.COMPOSITIONS, params, this.props.history);
    }

    handleResetFullText = () => {
        this.setState({fullText: ''}, () => {
            this.filterFullText('');
        });
    };

    handleKeyDownFullText = (e) => {
        if (e.key === 'Enter') {
            this.filterFullText(this.state.fullText);
        }
    }

    showFilterModal = () => {
        this.setState({filterModalVisible: true});
    }

    onFilterOk = (values) => {
        const params = {
            ...this.props[`${DataTypes.COMPOSITIONS}_params`],
            page: 1
        };
        params['filter'] = {};
        for (let i in values) {
            params['filter'][i] = values[i] || '';
        }
        this.props.loadCollection(DataTypes.COMPOSITIONS, params, this.props.history);
        this.setState({filterModalVisible: false});
    }

    onFilterCancel = () => {
        this.setState({filterModalVisible: false});
    }

    refresh = () => {
        this.props.loadCollection(DataTypes.COMPOSITIONS, this.props[`${DataTypes.COMPOSITIONS}_params`], this.props.history);
    }

    printSongbookIndex = () => {
        this.props.printSongbookIndex(this.props[`${DataTypes.COMPOSITIONS}_params`].filter.songbook, this.props.history);
    }

    printChoirSongbook = () => {
        this.props.printChoirSongbook(this.props[`${DataTypes.COMPOSITIONS}_params`].filter.songbook, this.props.history);
    }

    render() {
        const columns = [
            {
                title: 'Tytuł',
                dataIndex: 'title',
                key: 'title',
                sorter: true,
                defaultSortOrder: 'ascend',
                render: (text, record) => {
                    const le = record.last_event ? moment(record.last_event).format('YYYY-MM-DD') : null;
                    return <React.Fragment>
                        <Space>
                        <span>
                            {record.title}
                        </span>
                            {
                                record.link_count ? <Tooltip title="Linki do Youtube">
                                    <Youtube style={{color: "#cd201f"}}/>
                                </Tooltip> : ''
                            }
                            {
                                record.file_count ? <Tooltip title="Pliki z nutami">
                                    <File style={{color: "#3366ff"}}/>
                                </Tooltip> : ''
                            }
                            {
                                record.event_count ?
                                    <Tooltip title={`Liczba wystąpień w repertuarze. Ostatni raz: ${le}`}>
                                        <Badge style={{backgroundColor: '#1890ff'}} count={record.event_count}></Badge>
                                    </Tooltip> : ''
                            }
                        </Space>
                        {record.subtitle ? <p style={{fontSize: '0.8em'}}>{record.subtitle}</p> : ''}
                    </React.Fragment>
                }
            },
        ];

        return <React.Fragment>
            <div style={{padding: '0.5em 1em'}}>
                <Space>
                    <Button type="primary"
                            icon={<SearchOutlined/>}
                            onClick={this.showFilterModal}
                            title="Wyszukaj"/>
                    <Button type="primary"
                            icon={<ReloadOutlined/>}
                            onClick={this.refresh}
                            title="Odśwież"/>
                    <Button type="primary"
                            icon={<PrinterOutlined/>}
                            onClick={this.printSongbookIndex}
                            title="Drukuj spis utworów ze śpiewnika"
                            disabled={!this.props[`${DataTypes.COMPOSITIONS}_params`].filter.songbook}/>
                    {amIAdmin() ?
                        <Button type="primary"
                                icon={<PrinterFilled/>}
                                onClick={this.printChoirSongbook}
                                title="Drukuj cały śpiewnik dla chóru"
                                disabled={!this.props[`${DataTypes.COMPOSITIONS}_params`].filter.songbook}/>
                        : null
                    }
                </Space>
            </div>
            <CompositionFilterModal
                visible={this.state.filterModalVisible}
                handleOk={this.onFilterOk}
                handleCancel={this.onFilterCancel}
                sources={this.props.sources}
                categories={this.props.categories}
                songbooks={this.props.songbooks}
            />
            <div style={{padding: '1em'}}>
                <Input
                    placeholder="Szukaj po tytule"
                    value={this.state.fullText}
                    onChange={(e) => this.setState({fullText: e.target.value})}
                    onKeyDown={this.handleKeyDownFullText}
                    suffix={<CloseOutlined
                        onClick={this.handleResetFullText}/>}
                    addonAfter={<SearchOutlined
                        onClick={(e) => this.filterFullText(this.state.fullText)}/>}
                />
            </div>
            <Table
                size="small"
                columns={columns}
                dataSource={this.props.data}
                onRow={this.onRow}
                rowKey={'id'}
                rowClassName={this.setRowClassName}
                pagination={{
                    total: this.props.total,
                    current: this.props.params ? this.props.params.page : 1,
                    pageSize: this.props.params ? this.props.params.limit : 10,
                    pageSizeOptions: ['10', '20'],
                    showSizeChanger: false,
                    showQuickJumper: false,
                    //showTotal: this.showTotalItemsDialog,
                }}
                onChange={this.props.onChangeList}
            />
        </React.Fragment>
    }
}
